import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { ModalAnimation, ModalPosition, ModalSize } from "../../../services/modal.service";

@Component({
  selector: 'app-appmodal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './appmodal.component.html',
  styleUrl: './appmodal.component.css'
})
export class AppmodalComponent {

  @Input() title = '';
  @Input() bodyTemplate!: TemplateRef<any>;
  @Input() footerTemplate!: TemplateRef<any>;

  @Input() size: ModalSize = 'md';
  @Input() position: ModalPosition = 'center';
  @Input() animation: ModalAnimation = 'fade';
  @Input() drawer = false;
  @Input() width?: string;

  @Output() close = new EventEmitter<void>();

  onOverlayClick() {
    this.close.emit();
  }

  get modalClasses(): any {
    return {
     [`modal-${this.size}`]: true,
      [`modal-${this.position}`]: true,
      [`animate-${this.animation}`]: true,
      'modal-drawer': this.drawer
    };
  }

  get modalStyles(): { [key: string]: string } | null {
  if (!this.width) return null;

  return {
    width: this.width,
    maxWidth: this.width
  };
}

}
